module.exports = __webpack_public_path__ + "static/media/03_07_08.e87b1956.png";